import { render } from "./BeaconDetail.vue?vue&type=template&id=1fca4c8a"
import script from "./BeaconDetail.vue?vue&type=script&lang=js"
export * from "./BeaconDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__